export * from './providers/fan-deployment-profile.service';
export * from './models/fan-deployment-profile.model';
